import {getPinpointOs} from "./vendor/pinpointGetOs";

export interface PinpointCompatibleDevice {
    platform: {name: string; version?: string};
}

export function buildPinpointCompatibleDevice(userAgent: string, browserPlatform?: string): PinpointCompatibleDevice {
    const os = getPinpointOs(userAgent);
    const name = (os.name ?? browserPlatform ?? "").toLowerCase();

    return {
        platform: {
            name,
            ...(os.version ? {version: os.version} : {}),
        },
    };
}
